import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import S from './Footer.module.scss';
import PrivacyPolicy from '../PrivacyPolicy';

const Footer = () => {
  const { pathname } = useLocation();
  const [isFooterView, setIsFooterView] = useState<boolean>(true);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  useEffect(() => {
    if (pathname === '/login') {
      setIsFooterView(false);
    }
  }, [pathname]);

  return (
    <>
      <PrivacyPolicy isOpenModal={isOpenModal} setIsOpenModal={setIsOpenModal}></PrivacyPolicy>
      <footer
        className={`wrapper ${S.footer}`}
        style={isFooterView ? { display: 'flex' } : { display: 'none' }}
      >
        <div className={S.footer_menus}>
          <ul className={S.footer_menu_ul}>
            <li>
              <Link to="https://blog.naver.com/1vyleaguer" target="_blank">
                아이비리거 블로그
              </Link>
            </li>
            <li>
              <Link to="#" onClick={() => setIsOpenModal(true)}>
                개인정보처리방침
              </Link>
            </li>
            <li>
              <Link
                to="https://docs.google.com/forms/d/1YcwAfS408CUYRmrgE87zaZ_mnoWUPjvEZDQMdkl6wKE/edit"
                target="_blank"
              >
                고객문의
              </Link>
            </li>
          </ul>
        </div>
        <div className={S.footer_info}>
          <div className={S.site_name}>
            <h6 className="button-l">(주)아이비리거</h6>
          </div>
          <div className={S.business_info}>
            <div className={S.text_line}>
              <p className="b4">서울특별시 강남구 테헤란로8길 21, 8층</p>
              <p className={`b4 ${S.footer_devider}`}>I</p>
              <p className="b4">대표 : 주정호</p>
              <p className={`b4 ${S.footer_devider}`}>I</p>
              <p className="b4">개인정보보호관리자 : 주정호</p>
            </div>
            <div className={S.text_line}>
              <p className="b4">사업자등록번호 261-86-02932</p>
            </div>
            <div className={S.text_line}>
              <p className="b4">대표번호 : 02-2038-0088</p>
              <p className={`b4 ${S.footer_devider}`}>I</p>
              <p className="b4">대표이메일 : ivyleaguerhr@gmail.com</p>
            </div>
          </div>
          <div className={S.reserved_text}>
            <p className="b4">©IVYLEAGUER. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
